import { PanelModes, PanelNames } from "panels/constants"
import { useCallback } from "react"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { restoredFromSuspenseMemoryAction, setPanelModeAction } from "./actions"
import { selectPanelModeByName } from "./selectors"

export const usePanelState = (targetPanel: PanelNames) => {
    const dispatch = useAppDispatch()
    const mode = useAppSelector(selectPanelModeByName(targetPanel)) as PanelModes

    const setMode = useCallback(
        (mode: PanelModes, panel: PanelNames = targetPanel) => {
            dispatch(setPanelModeAction({ panel, mode }))
        },
        [dispatch, targetPanel]
    )

    const restoreSuspendedPanels = useCallback(() => {
        dispatch(restoredFromSuspenseMemoryAction())
    }, [dispatch])

    return {
        mode,
        isVisible: mode !== PanelModes.Hidden,
        isLockedPanel: mode === PanelModes.MaximizedLocked,
        isUnlockedPanel: mode !== PanelModes.MaximizedLocked,
        isTransitioning:
            mode === PanelModes.MaximizedTransitioning ||
            mode === PanelModes.MinimizedTransitioning,
        setMode,
        restoreSuspendedPanels,
    }
}

export default usePanelState
